import React, { useState, useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";
import { clearAllStores } from "../localdb/indexeddb";
import { SyncOfflineData } from "./SyncOfflineData";
import autonomizeLogo from "../assets/autonomizeLogo.png";

interface LayoutProps {
  children: React.ReactNode;
}

export function LayoutOld({ children }: LayoutProps) {
  const { user, logout } = useAuth();
  const [isMolinaTheme, setIsMolinaTheme] = useState(false);

  const handleLogout = async () => {
    try {

      await clearAllStores();

    } catch (error) {

    } finally {
      logout();
    }
  };

  useEffect(() => {
    if (isMolinaTheme) {
      document.body.classList.add("molina-theme");
    } else {
      document.body.classList.remove("molina-theme");
    }
  }, [isMolinaTheme]);

  const toggleTheme = () => {
    setIsMolinaTheme(!isMolinaTheme);
  };

  if (!user) return <>{children}</>;

  return (
    <div className="h-full flex flex-col bg-white">
      <nav className="bg-gradient-to-r from-purple-900 to-purple-700 text-white">
        <div className="px-6 py-3 bg-text-on-primary text-primary">
          <div className="flex justify-between items-center">
            <div className="flex items-center justify-between relative z-10">
              {/* <div className="flex-1 max-w-2xl">
              <div className="relative group">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                <input
                  type="text"
                  onClick={() => setCommandPaletteOpen(true)}
                  placeholder="Search or ask AI anything... (Ctrl+K)"
                  className="w-full pl-10 pr-20 py-2.5 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all cursor-pointer hover:border-purple-300"
                  readOnly
                />
                <div className="absolute right-3 top-1/2 transform -translate-y-1/2 flex items-center gap-1 px-2 py-1 bg-gray-100 rounded-lg border border-gray-200 text-xs text-gray-600">
                  <Sparkles className="w-3 h-3 text-purple-600" />
                  <kbd>⌘K</kbd>
                </div>
              </div>
            </div> */}

              <div className="flex items-center gap-3">
                {/* <svg
                  width="32"
                  height="32"
                  viewBox="0 0 100 100"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="50" cy="22" r="18" fill="#F5A623"></circle>
                  <path
                    d="M32 45 C32 39, 38 35, 50 35 C62 35, 68 39, 68 45 L68 95 L32 95 Z"
                    fill="#F5A623"
                  ></path>
                </svg> */}
                <img className="relative -top-0.5" width={28} src={autonomizeLogo} alt="Autonomize Logo" />
                <h1 className="text-2xl font-bold text-white">Agentic Care Management</h1>
                {/* <p className="text-purple-200 text-sm">
                    Phase 1: Member Understanding &amp; Risk Intelligence
                  </p> */}
              </div>

            </div>
            <div className="flex items-center gap-3">
              {user?.role === "admin" && (
                <div id="theme-option" className="flex items-center gap-2">
                  <span className="text-xs text-primary">Molina Theme</span>
                  <button
                    onClick={toggleTheme}
                    className={`relative inline-flex h-5 w-9 items-center justify-start rounded-full !p-0  ${isMolinaTheme
                      ? "bg-primary hover:bg-primary"
                      : "bg-gray-300 hover:bg-gray-300"
                      }`}
                    aria-label="Toggle Molina theme"
                  >
                    <span
                      className={`inline-block h-3 w-3 rounded-full bg-white ${isMolinaTheme
                        ? "translate-x-[1.25rem]"
                        : "translate-x-1"
                        }`}
                    />
                  </button>
                </div>
              )}
              {/* Sync Offline Data Button */}
              <SyncOfflineData />
              {/* <button className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition">
                <Bell className="w-4 h-4" />
              </button> */}
              <div className="flex items-center gap-2">
                <div className="w-7 h-7 bg-primary rounded-full flex items-center justify-center text-on-primary text-sm font-medium">
                  {user.fullName[0]}
                </div>
                <div className="text-left">
                  <div className="text-sm font-normal text-white">
                    {user.fullName}
                  </div>
                  <button
                    onClick={handleLogout}
                    className="text-xs text-white hover:text-white p-0"
                  >
                    Logout
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
      <main className="bg-gray-50 flex-auto overflow-auto">{children}</main>
    </div>
  );
}
